import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Material } from '../../warehouse/material/material';

@Injectable({ providedIn: 'root' })
export class ArticleScanAutocompleteService {
    presetMaterialSubject = new Subject<Material>();

    constructor() {}

    watchPresetMaterial(): Observable<Material> {
        return this.presetMaterialSubject.asObservable();
    }
}
